<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.0065 3.98547C9.37415 3.98547 3.98828 9.3709 3.98828 16.0043C3.98828 22.6376 9.37415 28.0231 16.0065 28.0231C22.6404 28.0231 28.0263 22.6376 28.0263 16.0043C28.0263 9.3709 22.6404 3.98547 16.0065 3.98547ZM16.0065 5.20872C21.9659 5.20872 26.8026 10.0461 26.8026 16.0043C26.8026 21.9626 21.9659 26.7998 16.0065 26.7998C10.0487 26.7998 5.21217 21.9626 5.21217 16.0043C5.21217 10.0461 10.0487 5.20872 16.0065 5.20872Z"
      fill="#141414"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.3939 16.2784L14.2865 19.171C14.5254 19.4099 14.9126 19.4099 15.1515 19.171L20.6198 13.7027C20.8585 13.464 20.8585 13.0764 20.6198 12.8377C20.3811 12.599 19.9935 12.599 19.7548 12.8377L14.719 17.8736L12.2588 15.4134C12.0201 15.1747 11.6326 15.1747 11.3939 15.4134C11.1552 15.6521 11.1552 16.0397 11.3939 16.2784Z"
      fill="#3CA091"
    />
  </svg>
</template>

<script>
export default {
  name: 'CheckCircle'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
